'use client'
import { FC, PropsWithChildren } from 'react'
import { useFlags } from 'launchdarkly-react-client-sdk'

import NavBar from '~/src/components/shared/NavBar'

import { getLogo, isPathInSidebar } from '~/src/navigation/helpers'

import SideBarWithSubmenus from '~/src/components/SideBarWithSubmenus'
import { SIDEBAR_ITEMS } from '~/src/navigation/sidebarConfig'

import { OperatorLayoutProps } from '~/app/types'

const OperatorNewDesktopLayout: FC<PropsWithChildren<OperatorLayoutProps>> = ({
  pathName,
  children,
  userRole,
  onAction,
}) => {
  const flags = useFlags() as Record<string, boolean>
  const logo = getLogo(pathName)

  const isSidebarRoute = isPathInSidebar(pathName, SIDEBAR_ITEMS)

  return (
    <div
      className={
        isSidebarRoute
          ? "grid h-screen w-screen grid-cols-[62px_auto] grid-rows-[60px_auto] [grid-template-areas:'sidebar_navbar'_'sidebar_main']"
          : "grid h-screen w-screen grid-cols-[62px_auto] [grid-template-areas:'sidebar_main']"
      }
    >
      <SideBarWithSubmenus
        flags={flags}
        items={SIDEBAR_ITEMS}
        userRole={userRole}
        onAction={onAction}
      />
      {isSidebarRoute && (
        <NavBar logo={logo} onOpenSettings={() => onAction?.('settings')} />
      )}
      <div className="min-h-0 overflow-hidden [grid-area:main]">{children}</div>
    </div>
  )
}

export default OperatorNewDesktopLayout
